// ** Icons Import
import { Folder, MessageSquare, CheckSquare, Calendar, FileText, Circle, ShoppingCart, User, Shield, Trello, Send, Monitor, Book, Users, Activity, Settings, Watch, File, BookOpen } from 'react-feather'

export default [
  {
    id: 'master',
    title: 'Data Master',
    icon: <Book size={20} />,
    action: 'read',
    resource: 'master',
    children: [
      {
        id: 'type',
        title: 'Type',
        icon: <Circle size={20} />,
        navLink: '/type',
        action: 'read',
        resource: 'master'
      },
      {
        id: 'merk',
        title: 'Merk',
        icon: <Circle size={20} />,
        navLink: '/merk',
        action: 'read',
        resource: 'master'
      },
      {
        id: 'engine',
        title: 'Engine',
        icon: <Circle size={20} />,
        navLink: '/engine',
        action: 'read',
        resource: 'master'
      },
      {
        id: 'category',
        title: 'Category',
        icon: <Circle size={20} />,
        navLink: '/category',
        action: 'read',
        resource: 'master'
      },
      {
        id: 'document',
        title: 'Document',
        icon: <Circle size={20} />,
        navLink: '/documents',
        action: 'read',
        resource: 'master'
      }
    ]
  },
  {
    id: 'aircrafts',
    title: 'Aircraft',
    icon: <Send size={20} />,
    navLink: '/aircrafts',
    action: 'read',
    resource: 'aircrafts'
  },
  {
    id: 'productivity',
    title: 'Productivity',
    icon: <Activity size={20} />,
    navLink: '/productivity',
    action: 'read',
    resource: 'productivity'
  },
  {
    id: 'users',
    title: 'Manage Users',
    icon: <Users size={20} />,
    navLink: '/users',
    action: 'read',
    resource: 'manageuser'
  },
  {
    id: 'profile',
    title: 'Settings Profile',
    icon: <User size={20} />,
    navLink: '/profile',
    action: 'read',
    resource: 'profile'
  }
]
